// extracted by mini-css-extract-plugin
export default {"action":"FlowActionComponent_action_XPw8_","allow":"FlowActionComponent_allow_KEu2C","deny":"FlowActionComponent_deny_YSGQ3"};